<template>
  <BreadCrumb PageTitle="Spinners" />
  <SpinnersContent />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../template-components/Common/BreadCrumb.vue";
import SpinnersContent from "../../template-components/UIElements/Spinners/SpinnersContent.vue";

export default defineComponent({
  name: "SpinnersPage",
  components: {
    BreadCrumb,
    SpinnersContent,
  },
});
</script>